module.exports = function(config) {
  const defaultConfig = require("./default.config.js");
  const projectConfig = require(`./${config}.config.js`);
  return Object.assign(defaultConfig, projectConfig);
};
